import { compose } from 'redux';
import { connect } from 'react-redux';
import DazePassageView from '../../../daze/pages/passage/DazePassageView';
import selectors from '../../../rootSelectors';
import {clearResponses, initResponsesStructure, completeMazeAssessment, setIsMazeUntimed } from '../../mazeActions';
import AvatarView from '../../../common/avatar/avatarView';
import withAvatar from '../../../common/avatar/withAvatar';
import { stopAudio } from '../../../common/audio/audioActions';
import {
    unmountScreen, enableTextPaneScroll, disableTextPaneScroll, blockScreen, unblockScreen,
    greyOutScreen, greyOutOkButton,
} from '../../../common/screen/screenActions';
import { onResponseSelected } from './MazePassageActions';
import { goToInterstitial } from '../../../common/navigation/navigationActions';
import { startTimeTracking, stopTimeTracking } from '../../../common/timeTracking/timeTrackingActions';
import { MAZE_PASSAGE_DURATION } from '../../../common/timeTracking/timeTrackingKeys';

const mapStateToProps = (state, ownProps) => ({
    isScreenBlocked: selectors.getIsScreenBlocked(state),
    isGreyedOut: selectors.getIsScreenGreyedOut(state),
    isOkButtonGreyedOut: selectors.getIsOkButtonGreyedOut(state),
    isNextButtonActive: selectors.getIsNextButtonActive(state),
    isDataFetched: selectors.getIsMazeDataFetched(state),
    paragraphs: selectors.getMazeParagraphs(state),
    questions: selectors.getMazeQuestionItems(state),
    title: selectors.getMazeTitle(state),
    selectedResponses: selectors.getMazeSelectedResponses(state),
    isScrollEnabled: selectors.getIsTextPaneScrollEnabled(state),
    isExtendedView: ownProps.isExtendedView,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    fetchContent: () => {
        dispatch(ownProps.flowStrategy.fetchContent());
    },
    initializePassage: () => {
        dispatch(enableTextPaneScroll());
        dispatch(initResponsesStructure());
        dispatch(startTimeTracking(MAZE_PASSAGE_DURATION));
    },
    onResponseSelected: (questionId, responseId) => {
        dispatch(onResponseSelected(questionId, responseId));
    },
    cleanup: () => {
        dispatch(stopAudio());
        dispatch(clearResponses());
        dispatch(disableTextPaneScroll());
        dispatch(unmountScreen());
    },
    onNext: (isDiscontinued, isRetry = false) => {
        dispatch(blockScreen());
        dispatch(greyOutScreen());
        dispatch(greyOutOkButton());
        dispatch(stopTimeTracking(MAZE_PASSAGE_DURATION));
        return dispatch(ownProps.flowStrategy.saveResponse(isDiscontinued, isRetry))
            .then(() => {
                dispatch(completeMazeAssessment(ownProps.flowStrategy.assessment));
                dispatch(unblockScreen());
                dispatch(goToInterstitial());
            });
    },
    setIsMazeUntimed: (isMazeUntimed) => {
        dispatch(setIsMazeUntimed(isMazeUntimed));
    },
});



const avatarMapStateToProps = (_, ownProps) => ({
    position: ownProps.isExtendedView ? AvatarView.Position.LOWER_FAR_LEFT : AvatarView.Position.LOWER_LEFT,
    instructions: ownProps.flowStrategy.instructions.passageInstruction,
});

const MazePassageContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(DazePassageView);

export default MazePassageContainer;
